import "core-js/modules/es.array.concat";
import "regenerator-runtime/runtime";
import { call } from 'redux-saga/effects';
import { FBUY_QUERY_PARAM } from 'redux/saga/selectors/friendbuy';
import { memberHasStatus } from 'redux/saga/helpers/member';
export var homepageOnEnter =
/*#__PURE__*/
regeneratorRuntime.mark(function homepageOnEnter(client, nextState, replaceState) {
  var fbuyQueryParamVal;
  return regeneratorRuntime.wrap(function homepageOnEnter$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          // If a user has a FriendBuy shortlink that redirects to a our homepage due to local caching,
          // we want to redirect them to the our dedicated referral page
          fbuyQueryParamVal = nextState.location.query[FBUY_QUERY_PARAM];

          if (!fbuyQueryParamVal) {
            _context.next = 5;
            break;
          }

          _context.next = 4;
          return call(replaceState, "/referral?".concat(FBUY_QUERY_PARAM, "=").concat(fbuyQueryParamVal));

        case 4:
          return _context.abrupt("return", _context.sent);

        case 5:
          _context.next = 7;
          return call(memberHasStatus, client, 'CANCELLED');

        case 7:
          if (!_context.sent) {
            _context.next = 10;
            break;
          }

          _context.next = 10;
          return call(replaceState, '/rejoin');

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, homepageOnEnter);
});